import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsWorkflow({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 1.5A.5.5 0 015 1h4a.5.5 0 01.5.5v1A.5.5 0 019 3H5a.5.5 0 01-.5-.5v-1zM3 2h.6v.9a1 1 0 001 1h4.8a1 1 0 001-1V2h.6a1.5 1.5 0 011.5 1.5v3.525A5 5 0 007.416 14H3a1.5 1.5 0 01-1.5-1.5v-9A1.5 1.5 0 013 2zm13 10a4 4 0 11-8 0 4 4 0 018 0zm-5.34-.744a.65.65 0 00-.92.919l1.368 1.367a.65.65 0 00.919 0l2.233-2.232a.65.65 0 00-.92-.92l-1.773 1.774-.907-.908z"
      />
    </svg>
  );
}

SvgSettingsWorkflow.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsWorkflow.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsWorkflow svgRef={ref} {...props} />
));
export default ForwardRef;
